/** O canal de uma conversa na tela: o nome e o glifo (#880; saiu de `atendimento/formato.ts`). */

/**
 * O canal fino da matriz da A03 vira nome que o vendedor reconhece.
 *
 * `whatsapp_cloud` é vocabulário nosso, de integração. Na tela ele é
 * "WhatsApp" — a §11 é explícita: a interface é desenhada por tarefa do
 * usuário, não como reprodução das engines.
 *
 * Canal desconhecido volta como veio, e de propósito: inventar "Outro"
 * esconderia um canal novo que ninguém mapeou, e o suporte perderia a pista.
 */
const NOMES_DE_CANAL: Record<string, string> = {
  whatsapp_cloud: 'WhatsApp',
  whatsapp_business: 'WhatsApp',
  whatsapp: 'WhatsApp',
  email: 'E-mail',
  webchat: 'Chat do site',
  web_widget: 'Chat do site',
  telegram: 'Telegram',
  instagram: 'Instagram',
  facebook: 'Facebook',
  sms: 'SMS',
  api: 'Integração',
};

export function nomeDoCanal(canal: string | null | undefined): string | null {
  if (!canal) return null;
  return NOMES_DE_CANAL[canal] ?? canal;
}

/**
 * O glifo do canal, ao lado do nome do contato (v3, #677).
 *
 * Só os canais que têm desenho na família de ícones; os outros (e-mail,
 * Telegram, SMS) ficam sem glifo e continuam ditos pelo nome na meta.
 */
export type IconeDeCanal = 'whatsapp' | 'instagram' | 'facebook' | 'web-chat' | 'api' | 'tiktok';

const ICONE_DO_CANAL: Record<string, IconeDeCanal> = {
  whatsapp_cloud: 'whatsapp',
  whatsapp_business: 'whatsapp',
  whatsapp: 'whatsapp',
  instagram: 'instagram',
  facebook: 'facebook',
  webchat: 'web-chat',
  web_widget: 'web-chat',
  api: 'api',
  tiktok: 'tiktok',
};

export function iconeDoCanal(canal: string | null | undefined): IconeDeCanal | null {
  if (!canal) return null;
  return ICONE_DO_CANAL[canal] ?? null;
}
